<div class="custom-chat border-left-blue-grey border-left-lighten-4 d-xl-block" id="chat">
  <a class="customizer-close" (click)="toggleChat($event)"><i class="feather ft-x font-medium-3"></i></a>

  <a class="customizer-toggle bg-danger box-shadow-3" (click)="toggleChat($event)"><i
      class="feather ft-message-square font-medium-5 spinner1 white"></i></a>
</div>

<p-sidebar [(visible)]="isChatOpen" position="right" [baseZIndex]="10000" class="liveChat" blockScroll="true">
  <app-live-chat *ngIf="isChatOpen" [mode]="modeType" [analytixData]="analytixData" [llmData]="llmData" [cfoDetails]="cfoDetails" [chatbotData]="chatbotData"></app-live-chat>
</p-sidebar>